import { Injectable } from '@angular/core';
import { ROUTE } from '../models/route';

@Injectable()
export class RouteService {
  constructor() {}

  getHomeRoute(): string[] {
    return [ROUTE.HOME];
  }

  getDefaultRoute(aanvraagId: string): string[] {
    return ['dossier', aanvraagId];
  }
  getDashboardUrl() {}
  getForbiddenRoute(): string[] {
    return [ROUTE.FORBIDDEN];
  }

  getAfschotmeldingRoute(meldingGuid: string): string[] {
    return [`/${ROUTE.DOSSIER}/${meldingGuid}`];
  }
}
